module.exports = __webpack_public_path__ + "media/images/ai_brain_topics/cancellation-589d0c579990cc8e21d84ffc3d4418e5.png";